import { Box } from '@mui/material';
import { FunctionComponent } from 'react';
import { useAppTranslate } from '../../../core/hooks';
import { L3ServiceStatusGroupApiModel } from '../../model';
import { serviceStatusColorMap } from '../../../l3-services/model';

interface Props {
  serviceStatusGroup: L3ServiceStatusGroupApiModel;
}

export const DashboardServiceStatusIcon: FunctionComponent<Props> = ({ serviceStatusGroup }) => {
  const translate = useAppTranslate();

  return <Box sx={{ display: 'flex', flexDirection: 'column' }}>
    <Box sx={{ fontSize: '0.875rem', fontWeight: 500, height: '3rem' }}>{translate(`cards.serviceStatus.status.${serviceStatusGroup.status}`)}</Box>
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Box sx={{ background: serviceStatusColorMap[serviceStatusGroup.status], borderRadius: '50%', height: '30px', width: '30px', mr: '1.5rem' }}></Box>
      <Box sx={{ fontSize: '0.875rem', fontWeight: 700 }}>{serviceStatusGroup.count || 0}</Box>
    </Box>
  </Box>;
};